export const checkMembershipStatus = (userInfo) => {
    const user = userInfo;
    const result = {
      isDisabled: !user.allowEdit,
      isMember: !user.membershipActive,
      membershipType: user.membershipActive ? user.membershipType : "Not a member yet",
      medal: "no-medal.png",
      expireDate: user.membershipActive ? user.formattedExpireDate : "N/A",
      status: user.membershipActive ? "Active" : "Not active",
    };
  
    // Determine the medal based on membershipType
    switch (user.membershipType) {
      case "Bronze":
        result.medal = "bronze-medal.png";
        break;
      case "Silver":
        result.medal = "silver-medal.png";
        break;
      case "WRJJ Membership":
        result.medal = "gold-medal.png";
        break;
      default:
        result.medal = "no-medal.png";
        break;
    }
  
    return result;
  };
  